import { cursorPaginationFieldPolicy } from '../../../utils/policies';
import type { TypePolicies } from '../../../utils/types/TypePolicies';
import { imageMerge } from '../utils';

const WORKFRONT_INTEGRATION = Object.freeze({
  integration: 'WORKFRONT',
  canUpdateInternalAssetContentSecurity: false,
  canUpdateWorkspaceName: false,
});

export const typePolicies: TypePolicies = {
  Workspace: {
    fields: {
      appliedResourceControlPolicies: {
        /**
         * The `AppliedResourceControlPolicy` type is non-normalized, for now. This makes
         * sense because There Can Be Only One (applied policy per workspace).
         */
        merge: true,
      },
      /**
       * This field is used to determine if the workspace has an externally managed integration
       * and look for that integration's specific restriction requirements rather than sprinkling
       * boolean flags integration specific throughout the client.
       * Currently there is no roadmap for additional integrations, but this can be extended in the future
       * The goal here is to limit business logic being baked into the client.
       * @todo (CSC-531): integration permissions policy on the backend to return this data
       * rather than the isWorkfront value returned now.
       */
      externallyManagedIntegration: {
        read(
          _,
          { readField }
        ): {
          integration: 'WORKFRONT';
          canUpdateInternalAssetContentSecurity: boolean;
          canUpdateWorkspaceName: boolean;
        } | null {
          if (readField('isWorkfront')) {
            return WORKFRONT_INTEGRATION;
          }
          return null;
        },
      },
      images: {
        merge: (existing, incoming) => imageMerge(existing, incoming),
      },
      projects: cursorPaginationFieldPolicy(['filter', 'orders']),
      resourceControlPolicies: {
        /**
         * The `ResourceControlPolicy` type is non-normalized, for now. This makes
         * sense because There Can Be Only One (policy per workspace).
         */
        merge: true,
      },
    },
  },
};
